import React, { useState, useEffect, useRef } from "react";
import PortalModal from "../../Portals";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  GET_QUESTIONS_IN_BANK,
  GET_QUESTIONS_IN_BANK_AFTER,
} from "../../GraphQL/Queries";
import { ADD_QUESTION_BANK_TO_SURVEY } from "../../GraphQL/Mutations";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  TextModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
  ContentModal,
  ActionButtons,
  ModalTitle,
  SearchField,
  QuestionsContainer,
  QuestionsContent,
  EmptyRecordContent,
  BlockWrapperSmileyFaces,
  BlockWrapperOpenText,
  BlockWrapperImageRating,
  BlockWrapperMultipleChoiceMultiSelect,
  BlockWrapperMultipleChoiceSingleSelect,
  BlockWrapperMultipleChoiceImageSingleSelect,
  BlockWrapperQuestionYesNo,
  BlockWrapperQuestionLike,
  BlockWrapperDropdownSingleSelect,
} from "./ModalQuestionBank.styled";
import { Form } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import ModalLoader from "../ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import { useMutation, useLazyQuery } from "@apollo/client";
import OpenTextBox from "../OpenTextBlock/OpenTextBox";
import SmileyFacesContainer from "../../containers/SmileyFacesContainer";
import ImageRatingContainer from "../../containers/ImageRatingContainer";
import MultipleChoiceMultiSelectContainer from "../../containers/MultipleChoiceMultiSelectContainer";
import MultipleChoiceSingleSelectContainer from "../../containers/MultipleChoiceSingleSelectContainer";
import MultipleChoiceSingleSelectImageContainer from "../../containers/MultipleChoiceSingleSelectImageContainer";
import QuestionYesNoContainer from "../../containers/QuestionYesNoContainer";
import QuestionLikeContainer from "../../containers/QuestionLikeContainer";
import DropdownSingleSelectContainer from "../../containers/DropdownSingleSelectContainer";
import { ReactComponent as QuestionUnselected } from "../../assets/svg/purple-circle-icon.svg";
import { ReactComponent as QuestionSelected } from "../../assets/svg/purple-circlewithtick-icon.svg";
import DateCalendarBlock from "../DateCalendarBlock/DateCalendarBlock";
import AttachFileBlock from "../AttachFileBlock";
import LocationTypeBlock from "../LocationTypeBlock/LocationTypeBlock";

const ModalQuestionBank = ({
  category,
  setModalVisibility,
  surveyId,
  fetchSurvey,
  setFetchSurvey,
}) => {
  const [searchTxt, setSearchTxt] = useState("");
  const [questionList, setQuestionList] = useState([]);
  const rSearch = useRef();
  const [recordsPerFetch] = useState(5);
  const [endCursor, setEndCursor] = useState("");
  const [addQuestionBankToSurvey] = useMutation(ADD_QUESTION_BANK_TO_SURVEY);

  useEffect(() => {
    runQuerytoGetQuestionsInBank();
  }, [searchTxt]);

  const [runQuerytoGetQuestionsInBank, { loading: loadingQuestions }] =
    useLazyQuery(GET_QUESTIONS_IN_BANK, {
      variables: {
        idcategoryQuestion: category?.id,
        searchBy: searchTxt,
        first: recordsPerFetch,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let questions = data?.questionsInBankByCategory?.edges;
        let questionsConfig = questions.map((item, index) => {
          item = item.node;
          let jsonConfSurveyQuestion = JSON.parse(item.jsonConfiguration);
          return {
            Gtype: jsonConfSurveyQuestion.typeQuestion,
            GindexQuestion: index,
            Gactive: true,
            GidSurvey: "",
            GidQuestion: item.idQuestion,
            GidCategoryQuestion:
              item.idQuestionNavigation.idCategoryQuestion.toString(),
            GnameQuestion: item.idQuestionNavigation.nameQuestion,
            GvalidationText: item.idQuestionNavigation.validationText,
            GidQuestionSurvey: item.idQuestionSurvey,
            GisMandatory: item.isMandatory,
            GjsonConfiguration: item.jsonConfiguration,
            Gorder: index + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: 0,
            GdependentAnswer: "",
            questionBank: true,
            questionSelected: false,
          };
        });
        setQuestionList(questionsConfig);
        if (data?.questionsInBankByCategory?.pageInfo.hasNextPage) {
          setEndCursor(data?.questionsInBankByCategory?.pageInfo.endCursor);
        } else {
          setEndCursor("");
        }
      },
    });

  const [
    runQuerytoGetQuestionsInBankAfter,
    { loading: loadingQuestionsAfter },
  ] = useLazyQuery(GET_QUESTIONS_IN_BANK_AFTER, {
    variables: {
      idcategoryQuestion: category?.id,
      searchBy: searchTxt,
      first: recordsPerFetch,
      after: endCursor,
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let questions = data?.questionsInBankByCategory?.edges;
      let questionsArr = [...questionList];
      let startIndex = questionsArr.length;
      questions.map((item, index) => {
        item = item.node;
        let jsonConfSurveyQuestion = JSON.parse(item.jsonConfiguration);
        questionsArr.push({
          Gtype: jsonConfSurveyQuestion.typeQuestion,
          GindexQuestion: startIndex,
          Gactive: true,
          GidSurvey: "",
          GidQuestion: item.idQuestion,
          GidCategoryQuestion:
            item.idQuestionNavigation.idCategoryQuestion.toString(),
          GnameQuestion: item.idQuestionNavigation.nameQuestion,
          GvalidationText: item.idQuestionNavigation.validationText,
          GidQuestionSurvey: item.idQuestionSurvey,
          GisMandatory: item.isMandatory,
          GjsonConfiguration: item.jsonConfiguration,
          Gorder: startIndex + 1,
          GisEdit: false,
          GisDependent: false,
          GidParentQuestion: 0,
          GdependentAnswer: "",
          questionBank: true,
          questionSelected: false,
        });
        startIndex++;
      });
      setQuestionList(questionsArr);
      if (data?.questionsInBankByCategory?.pageInfo.hasNextPage) {
        setEndCursor(data?.questionsInBankByCategory?.pageInfo.endCursor);
      } else {
        setEndCursor("");
      }
    },
  });

  const toggleQuestionSelection = (index) => {
    let questionsArr = [...questionList];
    questionsArr[index].questionSelected =
      !questionsArr[index].questionSelected;
    setQuestionList(questionsArr);
  };

  const setDataToSearchState = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        setDataToSearchState.apply(context, args);
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const handleScroll = ({ currentTarget }) => {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
        currentTarget.scrollHeight &&
      endCursor &&
      endCursor !== ""
    ) {
      runQuerytoGetQuestionsInBankAfter();
    }
  };

  const handleAddQuestionsToSurvey = () => {
    let questionsArr = [...questionList];
    questionsArr = questionsArr.filter((q) => q.questionSelected);
    let questionsIDSurvey = questionsArr.map((q) => q.GidQuestionSurvey);
    addQuestionBankToSurvey({
      variables: {
        questionSurveyIds: questionsIDSurvey,
        idSurvey: surveyId,
      },
    })
      .then((response) => {
        if (response?.data?.questionBankToSurvey) {
          setFetchSurvey(!fetchSurvey);
          NotificationManager.success(
            "Questions added to survey successfully",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const renderQuestions = (q) => {
    switch (q.Gtype) {
      case "OpenText":
        return (
          <>
            <BlockWrapperOpenText
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <OpenTextBox key={q.GidQuestion} {...q} />
            </BlockWrapperOpenText>
          </>
        );
      case "ImageRating":
        return (
          <>
            <BlockWrapperImageRating
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <ImageRatingContainer key={q.GidQuestion} {...q} />
            </BlockWrapperImageRating>
          </>
        );
      case "MultipleChoiceMultiSelect":
        return (
          <>
            <BlockWrapperMultipleChoiceMultiSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <MultipleChoiceMultiSelectContainer key={q.GidQuestion} {...q} />
            </BlockWrapperMultipleChoiceMultiSelect>
          </>
        );
      case "MultipleChoiceSingleSelect":
        return (
          <>
            <BlockWrapperMultipleChoiceSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <MultipleChoiceSingleSelectContainer {...q} key={q.GidQuestion} />
            </BlockWrapperMultipleChoiceSingleSelect>
          </>
        );
      case "MultipleChoiceImageSingleSelect":
        return (
          <>
            <BlockWrapperMultipleChoiceImageSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <MultipleChoiceSingleSelectImageContainer
                {...q}
                key={q.GidQuestion}
              />
            </BlockWrapperMultipleChoiceImageSingleSelect>
          </>
        );
      case "SmileyFaces":
        return (
          <>
            <BlockWrapperSmileyFaces
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <SmileyFacesContainer {...q} key={q.GidQuestion} />
            </BlockWrapperSmileyFaces>
          </>
        );
      case "QuestionYesNo":
        return (
          <>
            <BlockWrapperQuestionYesNo
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <QuestionYesNoContainer {...q} key={q.GidQuestion} />
            </BlockWrapperQuestionYesNo>
          </>
        );
      case "QuestionLike":
        return (
          <>
            <BlockWrapperQuestionLike
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <QuestionLikeContainer {...q} key={q.GidQuestion} />
            </BlockWrapperQuestionLike>
          </>
        );
      case "DropdownSingleSelect":
        return (
          <>
            <BlockWrapperDropdownSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <DropdownSingleSelectContainer {...q} key={q.GidQuestion} />
            </BlockWrapperDropdownSingleSelect>
          </>
        );
      case "Date":
        return (
          <>
            <BlockWrapperDropdownSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <DateCalendarBlock {...q} key={q.GidQuestion} />
            </BlockWrapperDropdownSingleSelect>
          </>
        );
      case "File":
        return (
          <>
            <BlockWrapperDropdownSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <AttachFileBlock {...q} key={q.GidQuestion} />
            </BlockWrapperDropdownSingleSelect>
          </>
        );
      case "Location":
        return (
          <>
            <BlockWrapperDropdownSingleSelect
              isDependent={q.GisDependent}
              key={q.GidQuestion}
            >
              {q.questionSelected ? (
                <QuestionSelected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              ) : (
                <QuestionUnselected
                  onClick={() => {
                    toggleQuestionSelection(q.GindexQuestion);
                  }}
                  className="question-select-icon"
                />
              )}
              <LocationTypeBlock {...q} key={q.GidQuestion} />
            </BlockWrapperDropdownSingleSelect>
          </>
        );
    }
  };

  return (
    <>
      <PortalModal>
        <ContentModal>
          <ContentModalActiveSurvey>
            <CloseModalActiveSurvey>
              <ModalTitle>Question Bank - {category?.description}</ModalTitle>
              <Tooltip title="close">
                <IconButton onClick={() => setModalVisibility(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </CloseModalActiveSurvey>
            <TextModalActiveSurvey>
              <SearchField>
                <SearchIcon />
                <Form.Control
                  type="text"
                  placeholder="Search here"
                  ref={rSearch}
                  onChange={handleSearch}
                />
              </SearchField>
              <QuestionsContainer onScroll={handleScroll}>
                <QuestionsContent>
                  {questionList.map((q) => {
                    return renderQuestions(q);
                  })}
                </QuestionsContent>
                {questionList.length == 0 && !loadingQuestions && (
                  <>
                    <EmptyRecordContent>
                      <p style={{ textAlign: "center" }}>No questions found</p>
                    </EmptyRecordContent>
                  </>
                )}
              </QuestionsContainer>
            </TextModalActiveSurvey>
            <ActionButtons>
              <ButtonActiveSurvey
                onClick={() => {
                  handleAddQuestionsToSurvey();
                  setModalVisibility(false);
                }}
              >
                Add
              </ButtonActiveSurvey>
              <ButtonActiveSurveyCancel
                onClick={() => setModalVisibility(false)}
              >
                Cancel
              </ButtonActiveSurveyCancel>
            </ActionButtons>
          </ContentModalActiveSurvey>
        </ContentModal>
      </PortalModal>
      {(loadingQuestions || loadingQuestionsAfter) && <ModalLoader />}
    </>
  );
};

export default ModalQuestionBank;
